import { z } from 'my-zod'
import { workOrderModel } from './work-order-model'

export const createWorkOrdersRequest = workOrderModel
  .pick({
    id: true,
    operatorId: true,
    isSafetyIssue: true,
    workToBeDone: true,
    serviceTaskIds: true,
    images: true,
    attachments: true,
    vehicleId: true,
    estimatedCompletionDate: true,
    workType: true,
    notes: true,
    estimatedWorkHours: true
  })
  .partial({
    id: true,
    notes: true
  })
  .augment({
    reduceInventory: z.boolean().optional(),
    // here so the seed function can pass the shortId which will be used to created the work order
    shortId: z.ostring()
  })

export type createWorkOrdersRequest = z.infer<typeof createWorkOrdersRequest>
